<template>
    <div class="page-content" id="planning-list">
        <Titlebar :incrustation="'fa-calendar'">
            <h1>{{ $t('planning.titles.list') }}</h1>
        </Titlebar>
        <div class="alert alert-info mb-4" v-html="$t('planning.descriptions.list')"></div>
        <UiCard>
            <SuperTable
                ref="tablePlannings"
                :tableColumns="tableColumns"
                :tableData="tableData ? tableData : []"
                @sort="handleSort"
                @filter="handleFilter"
                @delete="handleDelete"
                @copy="handleCopy"
                :loading="!tableData"
            />
        </UiCard>
        <Toolbar>
            <div class="row">
                <div class="col">
                    <Btn :class="'default'" v-can="'beepiz-add-profiles'">
                        <router-link :to="{name: 'PlanningNew'}">
                            <i class="fa fa-plus"></i><span>{{ $t('planning.btns.add') }}</span>
                        </router-link>
                    </Btn>
                </div>
                <div class="col center">
                    <Pagination ref="pagination" @change="handlePagination"></Pagination>
                </div>
                <div class="col">
                </div>
            </div>
        </Toolbar>
    </div>
</template>

<script>

    import axios from 'axios';
    import API from '@/services/API.js';
    import Utils from '@/services/utils.js'
    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import UiCard from "@/components/ui/Card";
    import Pagination from "@/components/ui/Pagination";
    import SuperTable from "@/components/ui/Table";
    import Globals from '@/services/globals.js';
    import moment from 'moment';

    import { planningListColumns } from "@/components/planning/list/columns";
    import {useDvFlag, useDvFlagAccess} from "../../services/featureFlag";

    export default {
        name: 'PlanningList',
        components: {
            Titlebar,
            Toolbar,
            UiCard,
            Btn,
            Pagination,
            SuperTable
        },
        data: () => ({
            count: 0,
            config: {
                perpage: Globals.perPage,
                fields: [],
                page: 1,
                filter: {
                    like: [],
                    equals: []
                },
                sort: ["+label"]
            },
            tableColumns: {
                global: {
                    sortable: false,
                    noItemsMsg: window.V.$i18n.t('planning.emptyTable')
                },
                columns: planningListColumns(window),
                rowActions: {
                    width: '15%',
                    actions: [
                        {
                            label: Utils.t('global.copy'),
                            class: 'fa fa-copy',
                            event: 'copy'
                        },
                        {
                            label: Utils.t('global.delete'),
                            class: 'fa fa-trash',
                            event: 'delete'
                        }
                    ]
                }
            },
            tableData: undefined
        }),
        methods: {
            dayName: function (day) {
                return moment().weekday(day-1).format('ddd');
            },
            handlePagination: function (page) {
                this.config.page = page;
                this.loadData();
            },
            handleSort: function () {
                this.config.sort = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeSort) {
                        this.config.sort.push(col.activeSort + col.key);
                    }
                }
                this.loadData();
            },
            handleFilter: function () {
                this.config.page = 1;
                this.config.filter.like = [];
                this.config.filter.equals = [];
                for (var colKey in this.tableColumns.columns) {
                    var col = this.tableColumns.columns[colKey];
                    if (col.activeFilter !== '') {
                        if (col.filter && col.filter.type == 'text') {
                            this.config.filter.like.push(col.key + ':' + col.activeFilter);
                        }
                        if (col.filter && col.filter.type == 'list') {
                            this.config.filter.equals.push(col.key + ':' + col.activeFilter);
                        }
                    }
                }
                this.loadData();
            },
            handleCopy: function (item) {
                window.V._router.push('/parameters/planning/' + item.id + '/copy');
            },
            handleDelete: function (item) {
                window.Vfc.$refs.confirm.show({
                    title: Utils.t('global.deleteModalTitle'),
                    content: Utils.t('global.deleteModalContent'),
                    callbackYes: () => {
                        axios.delete(API.route(API.endpoints.planning.delete, {planningId: item.id}))
                            .then(response => {
                                if(this.tableData.length == 1 && this.config.page > 1){
                                    this.config.page--;
                                }
                                this.loadData();
                            })
                            .catch(error => console.log(error))
                    }
                });
            },
            loadData: function () {
                this.tableData = undefined;
                axios.get(API.endpoints.planning.index + API.constructQueryParams(this.config))
                    .then(response => {
                        this.tableData = this.formatPlannings(response.data.data);

                        this.count = response.data.meta.pagination.total;
                        this.$refs.pagination.update(response.data.meta.pagination);
                    })
                    .catch(error => console.log(error))
            },
            formatPlannings: function(plannings) {
                return plannings.map(planning => {
                    const datisId = (planning?.datis ?? []).map(dati => dati.id.toString());

                    if (planning?.profiles && planning.profiles.length > 0) {
                        planning.profiles.forEach((element) => {
                            element.datis.forEach((dati) => {
                                if (!datisId.includes(dati.pivot.dati_id)) datisId.push(dati.pivot.dati_id)
                            });
                        })
                    }

                    if (planning?.groups && planning.groups.length > 0) {
                        planning.groups.forEach((element) => {
                            element.datis.forEach((dati) => {
                                if (!datisId.includes(dati.id.toString())) datisId.push(dati.id.toString())
                            });
                        })
                    }

                    const timeslotSumary = (planning?.timeslots ?? []).map(timeslot => {
                        if (timeslot.days.length > 0) {
                            const day = this.dayName(timeslot.days[0]);
                            const timeStart = timeslot.start_time.substring(0,5);
                            return `${day} ${timeStart}`
                        }
                        return undefined
                    }).filter(Boolean).join(', ');

                    return {
                        ...planning,
                        groupsCount: planning?.groups?.length ?? 0,
                        profilesCount: planning?.profiles?.length ?? 0,
                        datisCount: datisId.length,
                        timeslotSumary
                    }
                })
            }
        },

        watch: {
            tableData: {
                handler: function (val) {
                }
            }
        },

        mounted(){
          const flag = useDvFlag('beepiz-planning-reminder-can:read');
          if (!flag.access && flag.fallback==="no_plan") {
            this.$router.push({ name: 'AccessDenied', params: { slug: "planning"} })
          }
          else if (!flag.access && flag.fallback==="no_role") {
            this.$router.push({ name: 'AccessDenied', params: { slug: "planning_no_role"} })
          } else {
                window.Vfc.$refs.loading.hide();

                if(!useDvFlagAccess('beepiz-planning-reminder-can:delete')){
                    this.tableColumns.rowActions.actions.splice(1,1);
                }

                if(!useDvFlagAccess('beepiz-planning-reminder-can:create')){
                    this.tableColumns.rowActions.actions.splice(0,1);
                }

                this.loadData(1);
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
